import { render, staticRenderFns } from "./FrzAssignementCaliberNew.vue?vue&type=template&id=d32ab664"
import script from "./FrzAssignementCaliberNew.vue?vue&type=script&lang=js"
export * from "./FrzAssignementCaliberNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports